/*
 *   File : text-area.js
 *   Author : https://evoqins.com
 *   Description : Text area component
 *   Integrations : NA
 *   Version : 1.0.0
*/
import React, { memo, useState } from 'react';
import styles from '../../Style/Component/input.module.scss';

const CustomTextArea = (props) => {
    const [isInputFocused, setIsInputFocused] = useState(false);

    const _handleChange = (e) => {
        props.handleChange(e.target.value);
    };

    const handleFocus = () => {
        if (!props.readOnly) setIsInputFocused(true);
    };

    const handleBlur = () => {
        if (!props.readOnly) setIsInputFocused(false);
    };

    return (
        <div className={styles.e_textarea_wrap}>
            {props.label && (
                <label
                    className={`${props.labelStyle} e-primary-font e-text-rich-black e-font-weight-400 line-height-18px e-font-14 padding-6px-bottom`}
                >
                    {props.label}
                    {props.require && <span className='e-text-lust'>*</span>}
                </label>
            )}

            <div className={props.heightClassName}>
                <textarea
                    id={props.id}
                    value={props.value}
                    autoFocus={props.autoFocus}
                    className={`
                        ${props.className}
                        ${props.error ? "border-red-1px" : ""}
                        ${!props.readOnly && isInputFocused ? "e-border-input-focus" : `e-border-input ${props.borderStyle}`}
                        e-border-radius-8 
                        e-bg-white 
                        e-font-14 
                        e-text-raisin-black 
                        e-font-weight-400 
                        e-primary-font 
                        shadow-none 
                        resize-none 
                        ${props.readOnly ? styles.readonly_input : ""}
                    `}
                    placeholder={props.placeholder}
                    required={props.required}
                    rows={props.rows}
                    readOnly={props.readOnly}
                    cols={props.cols}
                    onChange={_handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />

                {props.error && (
                    <p className="mb-0 e-error-message e-primary-font e-font-10 line-height-12px pt-1">
                        {props.error}
                    </p>
                )}
            </div>
        </div>
    );
};

CustomTextArea.defaultProps = {
    handleChange: () => {},
    className: "",
    error: "",
};

export default memo(CustomTextArea);
